import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    Paper,
    Typography,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import actions from "../../../store/attestation/actions";
import {selectAttestationStatistic} from '../../../store/attestation/selectors';

type Props = {
    getStatistic: Function;
    statistic: any[];
};

const USER_TABLE_CELLS = [
    'Имя',
    'Логин',
    'Статус',
    'Результат',
    '',
];

const showStatus = (status: string) => {
    if (status === 'Skipped') {
        return '-'
    } else if (status === 'Passed') {
        return <DoneIcon />
    }
    return <CloseIcon />;
}
const View = ({getStatistic, statistic}: Props) => {

    useEffect(() => {
        getStatistic();
    }, []);
    return (
        <Paper sx={{p: 2}}>
            <Typography
                component='h2'
                sx={{
                    fontWeight: 'bold',
                    fontSize: '1.5rem',
                    color: '#507ebc',
                    marginBottom: '2em',
                }}
            >
                Аттестации
            </Typography>

            {statistic.map((attestation) => (
                <Box key={attestation.id}>
                    <Typography
                        component='h3'
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            color: '#507ebc',
                        }}
                    >
                        {attestation.name}
                    </Typography>
                    <TableContainer component={Box} sx={{mb: 4}}>
                        <Table sx={{minWidth: '200px'}}>
                            <TableHead>
                                <TableRow>
                                    {USER_TABLE_CELLS.map((cell) => (
                                    <TableCell key={cell}>{cell}</TableCell>
                                    ))} 
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* @ts-expect-error */}
                                {attestation.users.map(user => (
                                    <TableRow key={user.login}>
                                        <TableCell>{user.name}</TableCell>
                                        <TableCell>{user.login}</TableCell>
                                        <TableCell>{showStatus(user.status)}</TableCell>
                                        <TableCell>{(user.results || 0).toFixed(1)}</TableCell> 
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            ))}
        </Paper>
    )
}

//@ts-expect-error
const mapStateToProps = (state) => ({
    statistic: selectAttestationStatistic(state),
})

//@ts-expect-error
const dispatchProps = (dispatch) => ({
    getStatistic: bindActionCreators(actions.getAttestationStatistic, dispatch),
})


export default connect(mapStateToProps, dispatchProps)(View);